module.exports = __webpack_public_path__ + "img/aws.a7e580cb.png";